import systemConfigurationService from '@/services/api/systemConfigurationService';
import { useAuthStore } from '@/store/useAuthStore';
import { useSystemConfigurationStore, SystemConfigurationPayload } from '@/store/useSystemConfigurationStore';
import i18n from '@/i18n';
import { useToastStore } from '@/store/useToastStore';
import { ApiErrorInterface } from '@/models/ApiClientError';

export const loadPublicSystemConfiguration = async () => {
  const toastStore = useToastStore();
  const systemConfigurationStore = useSystemConfigurationStore();

  try {
    const systemConfiguration = await systemConfigurationService.getPublicSystemConfiguration();

    if (!systemConfiguration) {
      throw new Error('Unable to load public system configuration');
    }

    const payload: SystemConfigurationPayload = {
      redirect: false,
      systemConfiguration,
    };

    systemConfigurationStore.setSystemConfiguration(payload);
  } catch {
    const errorPosition = {
      x: 'center',
      y: 'top',
    };
    toastStore.error({
      message: i18n.global.t('apiErrors.publicSystemConfigurationFailed'),
      options: errorPosition,
    });
  }
};

export default async function loadSystemConfiguration(redirect = false): Promise<boolean> {
  const authStore = useAuthStore();
  const systemConfigurationStore = useSystemConfigurationStore();

  try {
    const systemConfiguration = await systemConfigurationService.getSystemConfiguration();

    if (!systemConfiguration) {
      throw new Error('Unable to load system configuration');
    }

    const payload: SystemConfigurationPayload = {
      redirect: redirect,
      systemConfiguration,
    };

    systemConfigurationStore.setSystemConfiguration(payload);
    return true;
  } catch (error) {
    if ((error as ApiErrorInterface).data?.httpCode === 401) {
      authStore.logout();
    }
    return false;
  }
}
